.profilePicture {
    max-height: 40px;
    border-radius: 100%;
    max-width: 40px;
}
